import { chatbotHttp as api } from "./chatbotApi";

const base = (botId) => `/bots/${encodeURIComponent(botId)}/schedules`;
const unwrap = (r) => r.data?.data;

export const listScheduleTypes = (botId) => api.get(`${base(botId)}/types`).then(unwrap);
export const listSchedules = (botId) => api.get(base(botId)).then(unwrap);
export const createSchedule = (botId, body) => api.post(base(botId), body).then(unwrap);
export const updateSchedule = (botId, id, body) => api.put(`${base(botId)}/${encodeURIComponent(id)}`, body).then(unwrap);
export const deleteSchedule = (botId, id, revision) =>
  api.delete(`${base(botId)}/${encodeURIComponent(id)}`, { params: { revision } }).then(unwrap);
export const listScheduleMessages = (botId, id, params) =>
  api.get(`${base(botId)}/${encodeURIComponent(id)}/messages`, { params }).then(unwrap);
export const listScheduleTools = (botId) => api.get(`${base(botId)}/tools`).then(unwrap);
export const testRunSchedule = (botId, body) => api.post(`${base(botId)}/test-run`, body).then(unwrap);
